import { render, staticRenderFns } from "./NotificationMassiveActionsDoc.vue?vue&type=template&id=5cba3364"
import script from "./NotificationMassiveActionsDoc.vue?vue&type=script&lang=js"
export * from "./NotificationMassiveActionsDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationMassiveActionsDoc.vue?vue&type=style&index=0&id=5cba3364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports